import React from "react";
import { SuccessStories } from "./results/SuccessStories";
import { Testimonials as ClientQuotes } from "./results/ResultsBlocks";

// Homepage "Women Who Got It Back" — same carousel + quotes as the Matrix results page.
const Testimonials = () => (
  <section id="success" className="scroll-mt-20 pb-20 bg-white/[0.015] border-y border-white/5" data-testid="home-success">
    <SuccessStories />
    <ClientQuotes />
  </section>
);

export default Testimonials;
